<div class="rx-intuitive-summary-footer" id="rx-summary-send-footer">
	<button tlkButton size="l" (click)="sendClicked.emit()" id="rx-summary-send-button">{{ 'IntuitivePatient.Confirm' | translate }} </button>
</div>
